import { Sites } from '@ps/platform-message-framework/common/Sites';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

const useRmfLogout = () => {
  const { auth } = useDispatch<Dispatch>();
  const site = useSelector(select.cms.getSiteId);

  return site === Sites.UK || site === Sites.DEN ? () => auth.logout() : undefined;
};

export default useRmfLogout;
